import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { TabsContent as BaseTabsContent, CountdownToEndOfWeek } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { t } from 'i18next';

export function TabsContent({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>) {
  return (
    <BaseTabsContent className={cn('flex-1 overflow-hidden', className)} {...props}>
      <div className="flex h-full flex-col">
        <div className="mx-auto mb-3 flex items-center justify-between gap-10">
          <h4 className="text-sm font-semibold text-foreground">{t('friends.weekly_rating')}</h4>
          <CountdownToEndOfWeek />
        </div>
        {children}
      </div>
    </BaseTabsContent>
  );
}
